(function(){
  if(window.__lmpHeaderSearchReady) return;
  window.__lmpHeaderSearchReady = true;

  function closeAll(except){
    document.querySelectorAll('[data-lmp-header-search]').forEach(function(panel){
      if(panel !== except){
        panel.hidden = true;
        panel.classList.remove('is-open');
      }
    });
    document.querySelectorAll('[data-lmp-header-search-open]').forEach(function(btn){
      var panelId = btn.getAttribute('aria-controls');
      if(!except || panelId !== except.id) btn.setAttribute('aria-expanded','false');
    });
  }

  document.addEventListener('click', function(event){
    var opener = event.target.closest('[data-lmp-header-search-open]');
    if(opener){
      event.preventDefault();
      var header = opener.closest('[data-lmp-header], [data-lmp-global-header]') || document;
      var panel = header.querySelector('[data-lmp-header-search]');
      if(!panel) return;
      var willOpen = panel.hidden;
      document.querySelectorAll('[data-lmp-header-panel]').forEach(function(item){ item.hidden = true; item.classList.remove('is-open'); });
      document.querySelectorAll('[data-lmp-header-panel-open]').forEach(function(btn){ btn.setAttribute('aria-expanded','false'); });
      closeAll(panel);
      panel.hidden = !willOpen;
      panel.classList.toggle('is-open', willOpen);
      opener.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      if(willOpen){
        window.setTimeout(function(){
          var input = panel.querySelector('input[type="search"], input[name="q"], input');
          if(input) input.focus({preventScroll:true});
        }, 80);
      }
      return;
    }
    if(event.target.closest('[data-lmp-header-search-close]')){
      var current = event.target.closest('[data-lmp-header-search]');
      closeAll();
      if(current) current.hidden = true;
      return;
    }
    if(!event.target.closest('[data-lmp-header-search], [data-lmp-header-search-open]')){
      closeAll();
    }
  });

  document.addEventListener('keydown', function(event){
    if(event.key === 'Escape') closeAll();
  });
})();
